export const BUSINESS_STATUS_LABLES = [
  {
    status: 0,
    label: "Pending Approval",
  },
  {
    status: 1,
    label: "Approved",
  },
  {
    status: 2,
    label: "InActive",
  },
];

export const PRODUCT_STATUS_LABLES = [
  {
    status: 0,
    label: "InActive",
  },
  {
    status: 1,
    label: "Active",
  },
];

export const BRAND_STATUS_LABLES = [
  {
    status: 0,
    label: "InActive",
  },
  {
    status: 1,
    label: "Active",
  },
];

export const ASSET_STATUS_LABLES = [
  {
    status: 0,
    label: "InActive",
  },
  {
    status: 1,
    label: "Active",
  },
  {
    status: 2,
    label: "Deactivated",
  },
];

export const ORDER_STATUS_LABLES = [
  {
    value: 0,
    label: "Pending",
  },
  {
    value: 1,
    label: "Success",
  },
  {
    value: 2,
    label: "On Hold",
  },
  {
    value: 3,
    label: "Shipped",
  },
  {
    value: 4,
    label: "Cancelled",
  },
];

export const TICKET_STATUS_LABLES = [
  {
    value: 1,
    label: "Open",
  },
  {
    value: 2,
    label: "In Progress",
  },
  {
    value: 3,
    label: "On Hold",
  },
  {
    value: 4,
    label: "Closed",
  },
];

export const TICKET_PRIORITY_LABLES = [
  {
    value: 0,
    label: "Low",
  },
  {
    value: 1,
    label: "Medium",
  },
  {
    value: 2,
    label: "High",
  },
  {
    value: 3,
    label: "Critical",
  },
];

// Mirror of Entities.Models.TicketSystem on flex2-api. Add new values both
// here and in the C# allow-list (TicketSystem.All) when they're introduced.
export const TICKET_SYSTEM_OPTIONS = [
  { value: "MANUAL", label: "Manual", bg: "#e2e8f0", fg: "#334155" },
  { value: "PICKUP", label: "Pickup", bg: "#dbeafe", fg: "#1d4ed8" },
  { value: "WORKORDER", label: "Workorder", bg: "#fef3c7", fg: "#92400e" },
];

export const getTicketSystemLabel = (value) => {
  if (!value) return "—";
  const opt = TICKET_SYSTEM_OPTIONS.find(
    (o) => o.value.toUpperCase() === String(value).toUpperCase()
  );
  return opt ? opt.label : value;
};

export const getTicketSystemStyle = (value) => {
  const opt = TICKET_SYSTEM_OPTIONS.find(
    (o) => o.value.toUpperCase() === String(value || "").toUpperCase()
  );
  return {
    backgroundColor: opt?.bg ?? "#f1f5f9",
    color: opt?.fg ?? "#475569",
  };
};

export const PART_STATUS_LABLES = [
  {
    value: 0,
    label: "InActive",
  },
  {
    value: 1,
    label: "Active",
  },
];

export const TASK_WORK_STATUS_LABLES = [
  {
    value: 1,
    label: "Open",
  },
  {
    value: 2,
    label: "In Progress",
  },
  {
    value: 3,
    label: "On Hold",
  },
  {
    value: 4,
    label: "Closed",
  },
];

export const TASK_WORK_PRIORITY_LABLES = [
  {
    value: 0,
    label: "Low",
  },
  {
    value: 1,
    label: "Medium",
  },
  {
    value: 2,
    label: "High",
  },
  {
    value: 3,
    label: "Critical",
  },
];

export const MAINTENACE_STATUS_LABLES = [
  {
    value: 1,
    label: "Pending",
  },
  {
    value: 2,
    label: "Due",
  },
  {
    value: 3,
    label: "Overdue",
  },
];

export const ASSET_MAINTENANCE_STATUS_LABLES = [
  {
    value: 0,
    label: "InActive",
  },
  {
    value: 1,
    label: "Upcoming",
  },
  {
    value: 2,
    label: "Due",
  },
  {
    value: 3,
    label: "Overdue",
  },
  {
    value: 4,
    label: "Done",
  },
];

export const INSPECTION_STATUS_LABLES = [
  {
    value: 0,
    label: "In Progress",
  },
  {
    value: 1,
    label: "Completed",
  },
  {
    value: 2,
    label: "Cancelled",
  },
];

export const INSPECTION_FORM_STATUS_LABLES = [
  {
    value: 0,
    label: "Draft",
  },
  {
    value: 1,
    label: "Active",
  },
  {
    value: 2,
    label: "Archived",
  }
];

export const INVOICE_STATUS_LABELS = [
  {
    value: 1,
    label: "Draft",
  },
  {
    value: 2,
    label: "Open",
  },
  {
    value: 3,
    label: "Paid",
  },
  {
    value: 4,
    label: "Overdue",
  },
  {
    value: 5,
    label: "Cancelled",
  },
];

export const ACTIVITY_EVENT_TYPES = [
  {
    value: 1,
    label: "Created",
  },
  {
    value: 2,
    label: "Updated",
  },
  {
    value: 3,
    label: "Message",
  }
];

// AFMS Redistribution Labels
export const REDISTRIBUTION_STATUS_LABELS = [
  { value: 1, label: "Triggered", color: "warning" },
  { value: 2, label: "Vendor Acknowledged", color: "info" },
  { value: 3, label: "Source Verification Pending", color: "warning" },
  { value: 4, label: "Source Verified", color: "info" },
  { value: 5, label: "Inquiry Sent", color: "primary" },
  { value: 6, label: "Awaiting Responses", color: "warning" },
  { value: 7, label: "Allocation Pending", color: "warning" },
  { value: 8, label: "Allocated", color: "info" },
  { value: 9, label: "Route In Progress", color: "primary" },
  { value: 10, label: "Route Completed", color: "success" },
  { value: 11, label: "Closed", color: "success" },
  { value: 12, label: "Cancelled", color: "error" },
];

export const INQUIRY_RESPONSE_STATUS_LABELS = [
  { value: 1, label: "Pending", color: "warning" },
  { value: 2, label: "Accepted", color: "success" },
  { value: 3, label: "Declined", color: "error" },
  { value: 4, label: "Expired", color: "default" },
];

export const ALLOCATION_METHOD_LABELS = [
  { value: 1, label: "Full Request" },
  { value: 2, label: "Pro-Rata" },
  { value: 3, label: "Priority-Based" },
  { value: 4, label: "Manual" },
];

export const DELIVERY_STATUS_LABELS = [
  { value: 1, label: "Pending", color: "warning" },
  { value: 2, label: "In Transit", color: "info" },
  { value: 3, label: "Arrived", color: "primary" },
  { value: 4, label: "Delivering", color: "primary" },
  { value: 5, label: "Completed", color: "success" },
  { value: 6, label: "Skipped", color: "default" },
  { value: 7, label: "Failed", color: "error" },
];

export const REDISTRIBUTION_ROLE_LABELS = [
  { value: 1, label: "Vendor" },
  { value: 2, label: "Source Site Manager" },
  { value: 3, label: "Heater Site Manager" },
  { value: 4, label: "Admin" },
];

export const NOTIFICATION_TYPE_LABELS = [
  { value: 1, label: "Case Triggered", icon: "notifications" },
  { value: 2, label: "Vendor Acknowledged", icon: "check_circle" },
  { value: 3, label: "Source Verified", icon: "verified" },
  { value: 4, label: "Inquiry Received", icon: "mail" },
  { value: 5, label: "Inquiry Response", icon: "reply" },
  { value: 6, label: "Allocation Complete", icon: "assignment" },
  { value: 7, label: "Route Started", icon: "local_shipping" },
  { value: 8, label: "Delivery Scheduled", icon: "schedule" },
  { value: 9, label: "Delivery Complete", icon: "done_all" },
  { value: 10, label: "Deadline Reminder", icon: "alarm" },
  { value: 11, label: "Case Closed", icon: "task_alt" },
  { value: 12, label: "Case Cancelled", icon: "cancel" },
];

export const USER_INVITATION_STATUS_LABELS = [
  { value: "pending", label: "Pending", color: "warning" },
  { value: "accepted", label: "Accepted", color: "success" },
  { value: "expired", label: "Expired", color: "error" },
  { value: "revoked", label: "Revoked", color: "dark" },
];

export const QUOTATION_STATUS_LABELS = [
  {
    value: 0,
    label: "Draft",
  },
  {
    value: 1,
    label: "Sent",
  },
  {
    value: 2,
    label: "Accepted",
  },
  {
    value: 3,
    label: "Paid",
  },  
  {
    value: 4,
    label: "Overdue",
  },
  {
    value: 5,
    label: "Cancelled",
  },
];
